import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "./util/conference/insertStylesToHead";
import React from "react";
import { createStore, applyMiddleware, compose } from "redux";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import reducer from "./reducers/events";
import EventDisplayRoute from "./components/event/eventDisplayRoute";
//import {HashRouter as Router } from 'react-router-dom'

import createHistory from "history/createHashHistory";

import { ConnectedRouter, routerMiddleware } from "react-router-redux";

import "./util/reset";
import "./util/apply-mediaquery";

// import locales
// change file for each page
// this helps reduce the bundle size
import en from "./locale/en/eventCalendar";
import fr from "./locale/fr/eventCalendar";

// initiate and set translations
import setTranslation from "./util/i18n";
setTranslation({
  en,
  fr
});

declare var window: any;

const history = createHistory();

const middleware = routerMiddleware(history);

export const store = createStore(
  reducer,
  compose(
    applyMiddleware(thunk, middleware),
    window.devToolsExtension && process.env.NODE_ENV === "development"
      ? window.devToolsExtension()
      : f => f
  )
);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <EventDisplayRoute />
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root") as HTMLElement
);
